exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-5d5ce1cd]{float:left;background-size:cover;background-repeat:no-repeat;background-position:50%;border:1px solid #ebebeb;margin:5px}", ""]);

// exports
